module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/murin5-74ee5e78b027d546999dc55b336819f5.jpg";